import React from 'react';
import Modal from '@/ctComponents/Modal';
import { createPortal } from 'react-dom';

const UpdateSubscriptionConfirmModal = ({
  show,
  memberName,
  handleConfirm,
  closePopup,
  loading = false,
}) => {
  const handleClose = () => {
    closePopup();
  };

  const handleSubmit = () => {
    handleConfirm();
  };

  if (!show) return null;

  return createPortal(
    <Modal
      show={show}
      children={
        <span
          style={{
            textAlign: 'center',
            width: '100%',
            marginTop: '24px',
          }}>
          Are you sure you want to update the subscription for{' '}
          <strong>{memberName}</strong>?
        </span>
      }
      submitText={'Yes, Update'}
      icon={'gem'}
      title={'Update User Subscription'}
      setShow={handleClose}
      submit={handleSubmit}
      loadingbutton={loading}
      customHandleClose={handleClose}
      noX={false}
    />,
    document.body
  );
};

export default UpdateSubscriptionConfirmModal;
